import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Breadcrumbs,
  Link,
  IconButton,
} from '@mui/material';
import { Home as HomeIcon, MenuBook as MenuBookIcon } from '@mui/icons-material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export const LssnPg = () => {
  const { classId, subjectId } = useParams();
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() =>  {
    const fetchLessons = async () => {
      try {
        const response = await fetch(
          'https://wsms.aidigitalsec.com/api/Teacher_Lessoon/ddlLession',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
              classId: parseInt(classId, 10),
              subjectId: parseInt(subjectId, 10),
            }),
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch lessons');
        }

        const data = await response.json();
        setLessons(Array.isArray(data) ? data : []);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLessons();
  }, [classId, subjectId]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>

      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#333" }}>
        Lessons
      </Typography>

      {lessons.length > 0 ? (
        <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Lesson</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lessons.map((lesson) => (
                <TableRow
                  key={lesson.lessionId}
                  hover
                  onClick={() =>
                    navigate(`/topics/${classId}/${subjectId}/${lesson.lessionId}`)
                  }
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <MenuBookIcon sx={{ mr: 1, color: 'primary.main' }} />
                      <Typography variant="body1">{lesson.lessionName}</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" color="text.secondary" textAlign="center" mt={4}>
          No lessons available.
        </Typography>
      )}
       <Box sx={{ my: 4 }}>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{
            background: 'linear-gradient(111.1deg, rgba(69,150,164,1) 2.5%, rgba(17,20,34,1) 100.3%)',
            color: '#fff',
            '&:hover': {
              background: 'linear-gradient(111.1deg, rgba(69,150,164,0.9) 2.5%, rgba(17,20,34,0.9) 100.3%)',
            },
          }}
        >
          Back
        </Button>
      </Box>
    </Box>
  );
};

export default LssnPg;
